import { GET_SETTING_REQUESTING, GET_SETTING_SUCCESS } from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SETTING_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_SETTING_SUCCESS: {
      const data = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
